import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { SCARequiresNextAction } from 'ha/services/apiV2/types/SCARequiresNextAction';
import { APIV2_URL } from './constants';

interface Payload {
  paymentType: string;
  billingCountry: string;
  signature: string;
  paymentMethodId?: number;
  stripeToken?: string;
  stripePaymentMethod?: string;
}

export default (makeCall: MakeCall) =>
  (conversationId: number, data: Payload) =>
    makeCall<Conversation | SCARequiresNextAction>(
      'PUT',
      `${APIV2_URL}/conversation/${conversationId}/payment`,
      {
        data,
        headers: {
          'X-HA-Features': 'enable-cc-sca',
        },
      },
    );
